module.exports = __webpack_public_path__ + "static/2-ec8d6afcea6eb9306e7b34c80d7fcb2d.jpg";